import React from 'react'
import styles from './WaveContainer.module.scss'
import Wave from 'images/wave.svg'
import WaveSlim from 'images/wave-slim.svg'
import { LanguageSwitch } from 'components/auth/common/LanguageSwitch/LanguageSwitch'
import { connect } from 'react-redux'
import { changeLanguage, getLanguage, submitGMA } from 'ducks/respondent.js'
import cx from 'classnames'
import { XIcon } from 'components/shared/Icon/model'
import { Icon } from 'components/shared/Icon/Icon'
import { t } from 'ttag'

export const WaveContainer = connect(
  state => ({ language: getLanguage(state) }),
  { changeLanguage, submitGMA },
)(
  ({
    changeLanguage,
    submitGMA,
    language,
    rollUp = false,
    children,
    containerRef,
    handleScroll,
    showFinishButton,
  }) => {
    return (
      <div
        className={styles.container}
        ref={containerRef}
        onScroll={handleScroll}
      >
        <div
          className={cx(styles.imageContainer, {
            [styles.rollUp]: rollUp,
          })}
        >
          <div
            className={cx(styles.topBackground, {
              [styles.rollUp]: rollUp,
            })}
          ></div>
          <img src={rollUp ? WaveSlim : Wave} alt="wave" />
          <div
            className={cx(styles.bottomBackground, {
              [styles.rollUp]: rollUp,
            })}
          ></div>
        </div>
        <div className={cx(styles.content, { [styles.rollUp]: rollUp })}>
          <div className={cx(styles.header, { [styles.rollUp]: rollUp })}>
            <div className={styles.exit} onClick={submitGMA}>
              {showFinishButton && (
                <>
                  <span className={styles.exitLabel}>{t`Finish`}</span>
                  <Icon className={styles.icon} icon={XIcon} size={20} />
                </>
              )}
            </div>
            <div className={styles.languagePicker}>
              <LanguageSwitch
                onSwitchLanguage={({ code }) => changeLanguage(code)}
                dark
                {...{ language }}
              />
            </div>
          </div>
          <div className={cx(styles.centerPanel, { [styles.rollUp]: rollUp })}>
            {children}
          </div>
        </div>
      </div>
    )
  },
)
